import { CircularMinus, CircularPlus } from '@components/icons'
import cn from 'clsx'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import s from './QuantityNew.module.css'

export interface QuantityNewProps {
  value: number
  increase: () => void
  decrease: () => void
  max?: number
  allowZero?: boolean
  className?: string
  disabled?: boolean
  disabledAmountSelection?: boolean
  quantityAvailable?: number
}

const QuantityNew: FC<QuantityNewProps> = ({
  value,
  increase,
  decrease,
  max = Infinity,
  allowZero = true,
  className,
  disabled,
  disabledAmountSelection,
  quantityAvailable,
}) => {
  const { t } = useTranslation('common')
  const isError =
    quantityAvailable && quantityAvailable > 0 && quantityAvailable < value
  return (
    <div className={cn('flex w-min items-center', className)}>
      <button
        type="button"
        onClick={decrease}
        className={cn(s.actionButton)}
        disabled={disabled || (allowZero ? value <= 0 : value <= 1)}
        aria-label={t('decrease', { defaultValue: 'Decrease' })}
      >
        <CircularMinus />
      </button>

      <div
        className={cn(s.inputWrapper, {
          'cursor-not-allowed opacity-50': disabledAmountSelection,
        })}
      >
        <span
          className={cn(s.inputValue, {
            'text-brand-dark-grey': !isError,
            'text-errorRed': isError,
          })}
        >
          {value}
        </span>
      </div>

      <button
        type="button"
        onClick={increase}
        className={cn(s.actionButton)}
        disabled={disabled || value >= max}
        aria-label={t('increase', { defaultValue: 'Increase' })}
      >
        <CircularPlus />
      </button>
    </div>
  )
}

export default QuantityNew
